import * as XLSX from "xlsx";

export const sheetDownload = async (dateFilter) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  try {
    const userInfo = JSON.parse(localStorage.getItem("PAuser"));
    const response = await fetch(`${backendUrl}/api/report/sheetDownload/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid: userInfo?.message?.result.id,
        durationType: dateFilter,
      }),
    });
    const json = await response.json();
    if (response.ok) {
      //console.log("rawData", json.data);
      let data = json?.data.map((it, index) => {
        let DbId = it.id;
        let keyword = it.brand;
        let platform = it.platform_name;
        let url = it.prod_link;
        let seller = it.seller_name;
        let lid = it.prod_code;
        let is_official_seller = it.seller_status === "W" ? "Yes" : "No";
        let is_reported = ["R", "TD","NC"].includes(it.status) ? "Yes" : "No";
        let is_removed = ["TD"].includes(it.status) ? "Yes" : "No";
        let is_test = it.test_purchase_status !== null ? "Yes" : "No";
        let is_counterfeit =
          it.test_purchase_status === 4
            ? "Yes"
            : it.seller_status === "C"
            ? "Yes"
            : "N/A";
        let date_detected = it.date_detected ? it.date_detected.split("T")[0] : "";
        let date_report = it.date_report ? it.date_report.split("T")[0] : "";
        let date_takendown = it.date_takendown ? it.date_takendown.split("T")[0] : "";
        let date_suspicious = it.date_suspicious ? it.date_suspicious.split("T")[0] : "";
        const abuse_type= it.abuse_type ? `${it.abuse_type} abuse` :" ";
        const isNonCompliance=it.status==="NC" ? "Non Compliant" :"";
        const isNonReportable=it.status==="NR" ? "Non Reportable" :"";
        let relevance=it.relevance ? it.relevance : "";
        const comments=it.comments? (JSON.parse(it.comments)).map(c=>c).join(", "):"";

  
        const comma1=(it.abuse_type && (isNonCompliance || isNonReportable || comments)) ? ", " : "";
        const comma2=((isNonCompliance || isNonReportable) && comments) ? ", " : "";

        let remarks=`${abuse_type}${comma1}${isNonCompliance}${isNonReportable}${comma2}${comments}`;


        return {
          "DB ID": DbId,
          Keyword: keyword,
          Platform: platform,
          URL: url,
          Seller: seller,
          LID: lid,
          "Official Seller": is_official_seller,
          is_reported: is_reported,
          is_removed: is_removed,
          is_test_purchase: is_test,
          is_counterfeit: is_counterfeit,
          "Date Detected": date_detected,
          "Date Report": date_report,
          "Date Takendown": date_takendown,
          "Date Suspicious": date_suspicious,
          "Relevance": relevance,
          "Remarks": remarks
        };
      });

      // Convert data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Create a new workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Generate an Excel file and trigger a download
      XLSX.writeFile(workbook, "report.xlsx");
    } else if (response.status === 400) {
      //console.log(json);
    }
  } catch (e) {
    //console.log("error in sheetdownload", e);
  }
};
